







import { Component, Vue } from "vue-property-decorator";

@Component({
  
})
export default class PageNotFound extends Vue {
  mounted(){
    this.$emit("loaded");
  }
}
